import { WritableSignal } from '@angular/core';
import { Observable } from 'rxjs';

import { MutationResult, UpdateRequestResponse, UpdateResponse } from '@shure/cloud/shared/models/http';
import { DeviceBluetoothPower } from '@shure/shared/angular/data-access/system-api/models';

import {
	UpdateDeviceFirmwareInput,
	AssociateTagMutationOpResult,
	DissociateTagMutationOpResult,
	RequestFirmwareUpdateInput
} from '../api-instance-sys-api/graphql/generated/cloud-sys-api';

export type UpdateDeviceFirmwareApiInput = UpdateDeviceFirmwareInput & { isHosted: boolean };
export type RequestFirmwareUpdateApiInput = RequestFirmwareUpdateInput & { isHosted: boolean };

export type AssociateTagMutationResult = MutationResult<AssociateTagMutationOpResult['associateTag']>;
export type DissociateTagMutationResult = MutationResult<DissociateTagMutationOpResult['dissociateTag']>;

export abstract class CloudDeviceApiService {
	public abstract readonly lastFWUpdateTime: WritableSignal<number>;

	public abstract setIdentify(deviceId: string, identify: boolean): Observable<UpdateRequestResponse<string>>;
	public abstract setMute(deviceId: string, deviceMute: boolean): Observable<UpdateRequestResponse<string>>;
	public abstract setDeviceName(deviceId: string, name: string): Observable<UpdateResponse<void, string>>;
	public abstract rebootDevice$(deviceId: string): Observable<UpdateResponse<void, string>>;
	public abstract associateTag(deviceIds: string[], tag: string): Observable<AssociateTagMutationResult>;
	public abstract dissociateTag(deviceIds: string[], tag: string): Observable<DissociateTagMutationResult>;
	public abstract setIotRoomProxy(deviceId: string, enabled: boolean): Observable<UpdateResponse<void, string>>;
	public abstract submitFirmwareUpdateRequests(
		updates: RequestFirmwareUpdateApiInput[]
	): Observable<UpdateResponse<void, string>>;

	// Auracast Mutations
	public abstract setAuracastEnabled(channelId: string, enabled: boolean): Observable<UpdateResponse<void, string>>;
	public abstract setBroadcastName(
		channelId: string,
		broadcastName: string
	): Observable<UpdateResponse<void, string>>;
	public abstract enableBroadcastCode(
		channelId: string,
		passphrase: string
	): Observable<UpdateResponse<void, string>>;
	public abstract disableBroadcastCode(channelId: string): Observable<UpdateResponse<void, string>>;
	public abstract setBluetoothPowerLevel(
		deviceId: string,
		bluetoothPower: DeviceBluetoothPower
	): Observable<UpdateResponse<void, string>>;
}
